import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/system/job/snippet/page', data, {
    trim: true
  })
}

// 删除
export function deleteById (id) {
  return request.get(`/system/job/snippet/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/system/job/snippet/delete/batch', {
    params: {
      ids
    }
  })
}

// 查询
export function trigger (data) {
  return request.post('/system/job/snippet/trigger', data)
}
